export default __webpack_public_path__ + "static/media/income_proj_05.0e301421.png";